export default function mask() {
  $('#phone').on('input', function() {
    var valor = $(this).val()
    var numeros = valor.replace(/\D/g, '')
    $(this).val(numeros)
    if (numeros.length > 0) {
      valor = '(' + numeros
      if (numeros.length > 3) {
        valor = valor.substring(0, 3) + ') ' + valor.substring(3)
      }
      if (numeros.length > 10) {
        valor = valor.substring(0, 10) + '-' + valor.substring(10)
      }
      $(this).val(valor)
    }
  })
}
